import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DocumentsRoutingModule } from './documents-routing.module';
import { SharedDocumentsComponent } from './shared-documents/shared-documents.component';
import { CoreModule } from '../core/core.module';
import { MaterialModule } from '../shared/material.module';
import { UploadDocumentsComponent } from './upload-documents/upload-documents.component';
import{  DndDirective } from './directive/dnd.directive';
import { ToolTipComponent } from './tool-tip/tool-tip.component';
import { DownloadPreviewComponent } from './download-preview/download-preview.component';
import { TooltipModule } from 'ng2-tooltip-directive';
import { FoldersViewComponent } from './folders-view/folders-view.component';
import { DocumentSearchGridComponent } from './document-search-grid/document-search-grid.component';
import { SearchViewComponent } from './search-view/search-view.component';
import { DownloadEditComponent } from './download-edit/download-edit.component';
import { UploadDocumentsDeleteDialogsComponent } from './dialogs/upload-documents-delete-dialogs/upload-documents-delete-dialogs.component';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { PreviewDocumentComponent } from './dialogs/preview-document/preview-document.component';

@NgModule({
  declarations: [
    SharedDocumentsComponent,
    ToolTipComponent,
    UploadDocumentsComponent,    
    DndDirective,
    DownloadPreviewComponent,
    FoldersViewComponent,
    DocumentSearchGridComponent,
    SearchViewComponent,
    DownloadEditComponent,
    UploadDocumentsDeleteDialogsComponent,
    PreviewDocumentComponent,
  ],
  imports: [
    CommonModule,
    DocumentsRoutingModule,    
    CoreModule,
    MaterialModule,
    TooltipModule,
    NgxDocViewerModule
  ],
  exports: [
    SharedDocumentsComponent,      
    DndDirective,    
  ]
})
export class DocumentsModule { }
